import React, { useContext } from 'react';
import { Link as ReachLink, Route } from 'react-router-dom';

import { ComponentContext } from '../../../context/componentContext';
import { AuthContext } from '../../../context/authContext';
import { Box, Link, Text } from '@chakra-ui/core';
import MemoProfile from '../../SVG/Profile';
import MemoSupport from '../../SVG/Support';
import MemoLogout from '../../SVG/Logout';

const ProfileMenu = () => {
  const { toggleAccount, ref, handleToggleAccount, handleToggleSupport } = useContext(
    ComponentContext
  );
  const { isAuthenticated, logout } = useContext(AuthContext);

  const { firstName, lastName, _id } = isAuthenticated().user;

  const logoutButton = () => (
    <Route
      render={({ history }) => (
        <Text
          as="span"
          onClick={() => logout(_id, () => window.location.reload())}
          color="gray.600"
          mt={0}
          py={2}
          px={4}
          cursor="pointer"
          d="flex"
          alignItems="center"
          className=" hover:text-white  hover:bg-cf-300"
        >
          <Text as="span" mr={2}>
            <MemoLogout />
          </Text>{' '}
          Logout
        </Text>
      )}
    />
  );

  const duration = 300;

  return (
    <>
      <Box
        pos="fixed"
        zIndex={40}
        right={0}
        mt={20}
        mr={{ md: 8 }}
        transform={toggleAccount ? `translateY(0)` : `translateY(-100%)`}
        opacity={toggleAccount ? 1 : 0}
        transition={
          toggleAccount ? `transform ${duration}ms ease-out` : `transform ${duration}ms ease-in-out`
        }
      >
        <Box mt={3} bg="white" border={{ xl: 1 }} rounded="xs" w={48} py={2} shadow="lg">
          <Text
            px={4}
            py={2}
            fontSize="base"
            color="cf.400"
            borderBottomWidth="1px"
            borderBottomColor="cf.400"
          >
            {firstName} {lastName}
          </Text>
          <Link
            as={ReachLink}
            onClick={handleToggleAccount}
            to="/profile"
            d="flex"
            _hover={{ textDecor: 'none', color: 'white', bg: 'cf.400' }}
            color="gray.600"
            mt={0}
            px={4}
            py={2}
            alignItems="center"
          >
            <Text as="span" mr={2}>
              <MemoProfile />
            </Text>{' '}
            Profile
          </Link>
          <Box
            d={{ base: 'flex', md: 'none' }}
            _hover={{ textDecor: 'none', color: 'white', bg: 'cf.400' }}
            color="gray.600"
            mt={0}
            px={4}
            py={2}
            alignItems="center"
            onClick={handleToggleSupport}
          >
            <Text as="span" mr={2}>
              <MemoSupport />
            </Text>{' '}
            Support
          </Box>
          {logoutButton()}
        </Box>
      </Box>
    </>
  );
};

export default ProfileMenu;
